// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { isFunction, omit } from 'lodash'
import { TextField as MuiTextField, FormControl } from '@mui/material'
// Assets
import { events } from '@ggs/utils'
import './_TextField.scss'

const TextField = (props) => {
  const {
    className,
    name,
    icon,
    onChange,
    onBlur,
    value: formikValue,
    variant = 'outlined',
    labelProps = {},
  } = props
  const [value, setValue] = useState(formikValue)
  const handleChange = (event) => {
    setValue(event.target.value)
    isFunction(onChange) && onChange(event)
  }

  // console.log("TextFieldProps:", props)

  const reset = () => {
    handleChange(events.syntheticInputEvent(name, { value: '' }))
  }

  useEffect(() => {
    const newValue = formikValue || ''
    setValue(newValue)
  }, [formikValue])
  const extraProps = omit(props, ['value'])

  return (
    <>
      {icon !== null && icon}
      <FormControl variant="standard">
        <MuiTextField
          {...extraProps}
          name={name}
          onChange={handleChange}
          onBlur={onBlur}
          value={value || ''}
          className={`${className} form-field__text-field`}
          variant={variant}
          InputLabelProps={labelProps}
          margin="normal"
        />
        <button
          className="form-field__reset"
          data-name={name}
          type="button"
          aria-hidden
          onClick={reset}
        />
      </FormControl>
    </>
  )
}

// Exports
// TextField.defaultProps = defaultProps
// TextField.propTypes = propTypes
TextField.displayName = 'TextField'
export default TextField
